import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { InjectedStyledComponent } from '../shared/InjectedStyledComponent.js';

import { IColumnSelectorProps, IColumnSelectorState } from './models/index.js';
import DropdownComponent from './styledComponents/DropdownComponent.js';
import Wrapper from './styledComponents/Wrapper.js';

export class RawColumnSelector extends Component<IColumnSelectorProps, IColumnSelectorState> {
	static configurationKey = 'columnSelector' as const;
	static styleKey = 'columnSelector' as const;
	constructor(props: IColumnSelectorProps) {
		super(props);
	}
	render() {
		const { className, columnSelectorStore } = this.props;

		if (!columnSelectorStore) {
			return null;
		}

		const {
			listHeading,
			selectAllButton,
			clearAllButton,
			headerOptions,
			searchInput,
			columns,
			selectedColumns,
			placeholder,
			onItemSelect,
		} = columnSelectorStore;

		return (
			<Wrapper className={className}>
				<DropdownComponent
					label={headerOptions.labelOptions.label}
					placeholder={placeholder}
					selectedPlaceholder={null}
					onChange={onItemSelect}
					isMultiSelect
					items={columns}
					selectedItem={selectedColumns}
					listHeading={listHeading}
					inputs={{
						selectAllButton,
						clearAllButton,
					}}
					headerOptions={headerOptions}
					searchInput={searchInput}
				/>
			</Wrapper>
		);
	}
}

export const ColumnSelector = inject('appStore', 'columnSelectorStore')(observer(RawColumnSelector));
export default InjectedStyledComponent(ColumnSelector, 'columnSelector', undefined, undefined, undefined, undefined);
